// Cross-page try-on tracker. The id is persisted the moment the generation
// exists, so a navigation mid-poll resumes it (or surfaces the ready/error pill
// on the next page) instead of stranding a running job.
const PENDING_KEY = "vc_pending_tryon"

export type OriginProduct = { name: string; url: string }

export type PendingRecord = {
  id: string | number | null
  status: "generating" | "ready" | "error"
  resultUrl?: string
  message?: string
  product?: OriginProduct
}

export function save(record: PendingRecord) {
  if (record.id == null) return
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(record))
  } catch (_error) { /* storage unavailable — degrade to in-memory only */ }
}

export function load(): { id: string | number; status: string; resultUrl?: string; message?: string; product?: OriginProduct } | null {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && parsed.id != null ? parsed : null
  } catch (_error) {
    return null
  }
}

export function remove() {
  try {
    sessionStorage.removeItem(PENDING_KEY)
  } catch (_error) { /* ignore */ }
}
